import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel } from 'rsuite'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PersonalBasicInfo from '../../../widgets/personalBasicInfo/PersonalBasicInfo'
import CompanyBasicInfo from '../../../widgets/companyBasicInfo/CompanyBasicInfo'
import AddressWork from '../../../widgets/address/addressWork/AddressWork'
import AddressCard from '../../../widgets/address/addressCard/AddressCard'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import AddressDeliveryDocument from '../../../widgets/address/addressDeliveryDocument/AddressDeliveryDocument'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSchemaSubProjectProposalGranteeBasicInfo } from '../../../redux/actions/proposalGranteeBasicInfo'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import CurrentAddress from '../../../widgets/address/currentAddress/CurrentAddress'

export default function GranteeBasicInfoSubProject() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [addressWork, setAddressWork] = useState()
  const [addressCard, setAddressCard] = useState()
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const type = 'grantee'

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let _schema = await getSchemaSubProjectProposalGranteeBasicInfo(projectId)

      if (_schema?.forms?.currentAddress) {
        setAddressWork(initAddress(_schema?.forms?.currentAddress))
      } else {
        setAddressWork(initAddress(_schema?.forms?.companyAddress))
      }

      setAddressCard(initAddress(_schema?.forms?.idCardAddress))

      setSchema(_schema)
      setIsEditWidget({
        persomal: _schema.forms?.persomal?.id ? false : true,
        company: _schema.forms?.company?.id ? false : true,
        companyAddress: _schema.forms?.companyAddress?.id ? false : true,
        idCardAddress: _schema.forms?.idCardAddress?.id ? false : true,
        documentAddress: _schema.forms?.documentAddress?.id ? false : true,
        officeLocation: _schema.forms?.officeLocation?.id ? false : true,
        formAddress: _schema.forms?.formAddress?.id ? false : true,
        currentAddress: _schema.forms?.currentAddress?.id ? false : true,
      })

      setShowEditAll(
        !_schema.forms?.persomal?.disabled &&
          !_schema.forms?.company?.disabled &&
          !_schema.forms?.companyAddress?.disabled &&
          !_schema.forms?.idCardAddress?.disabled &&
          !_schema.forms?.documentAddress?.disabled &&
          !_schema.forms?.officeLocation?.disabled &&
          !_schema.forms?.formAddress?.disabled &&
          !_schema.forms?.currentAddress?.disabled
      )
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const initAddress = (address) => {
    return {
      buildingName: address?.buildingName?.value,
      roomNumber: address?.roomNumber?.value,
      houseNumber: address?.houseNumber?.value,
      villageNumber: address?.villageNumber?.value,
      lane: address?.lane?.value,
      villageName: address?.villageName?.value,
      road: address?.road?.value,
      location: address?.location?.value,
      telephone: address?.telephone?.value,
      mobile: address?.mobile?.value,
      fax: address?.fax?.value,
      email: address?.email?.value,
    }
  }

  const handleOnSubmitAddressWork = (value) => {
    setAddressWork(value)
  }

  const handleOnSubmitAddressCard = (value) => {
    setAddressCard(value)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isSubProject>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
        />
      )}

      <Panel header={schema.header} shaded>
        <CustomIconMessageInfo content={schema.forms?.granteeInfo?.messageInfo} />
      </Panel>
      <br />

      {/* สำหรับบุคคลธรรมดา */}
      {schema?.forms?.persomal && (
        <>
          <PersonalBasicInfo
            showCommandButton={!schema.forms.persomal.disabled}
            honorificOptions={schema.forms.honorificOptions}
            schema={schema.forms.persomal}
            isEdit={isEditWidget.persomal && !schema.forms.persomal.disabled}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('persomal', _isEdit, setIsEditWidget)}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* สำหรับนิติบุคคล */}
      {schema?.forms?.company && (
        <>
          <CompanyBasicInfo
            showCommandButton={!schema.forms.company.disabled}
            schema={schema.forms.company}
            isEdit={isEditWidget.company && !schema.forms.company.disabled}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('company', _isEdit, setIsEditWidget)}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* ที่อยู่ปัจจุบัน (บุคคลธรรมดา)*/}
      {schema?.forms?.currentAddress && (
        <>
          <CurrentAddress
            showCommandButton={!schema.forms.currentAddress.disabled}
            schema={schema.forms.currentAddress}
            isEdit={isEditWidget.currentAddress && !schema.forms.currentAddress.disabled}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('currentAddress', _isEdit, setIsEditWidget)
            }
            handleOnSubmit={handleOnSubmitAddressWork}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* สำหรับนิติบุคคล */}
      {schema?.forms?.companyAddress && (
        <>
          <AddressWork
            showCommandButton={!schema.forms.companyAddress.disabled}
            schema={schema.forms.companyAddress}
            isEdit={isEditWidget.companyAddress && !schema.forms.companyAddress.disabled}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('companyAddress', _isEdit, setIsEditWidget)
            }
            handleOnSubmit={handleOnSubmitAddressWork}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* ที่อยู่ตามบัตรประจำตัวประชาชน (บุคคลธรรมดา)*/}
      {schema?.forms?.idCardAddress && (
        <>
          <AddressCard
            showCommandButton={!schema.forms.idCardAddress.disabled}
            schema={schema.forms.idCardAddress}
            isEdit={isEditWidget.idCardAddress && !schema.forms.idCardAddress.disabled}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('idCardAddress', _isEdit, setIsEditWidget)
            }
            handleOnSubmit={handleOnSubmitAddressCard}
            addressWork={addressWork}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* ที่อยู่ที่จัดส่งเอกสาร (บุคคลธรรมดา,นิติบุคล)*/}
      {schema?.forms?.documentAddress && (
        <>
          <AddressDeliveryDocument
            showCommandButton={!schema.forms.documentAddress.disabled}
            schema={schema.forms.documentAddress}
            isEdit={isEditWidget.documentAddress && !schema.forms.documentAddress.disabled}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('documentAddress', _isEdit, setIsEditWidget)
            }
            addressWork={addressWork}
            addressCard={addressCard}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* ที่อยู่สถานที่ทำงาน (บุคคลธรรมดา)*/}
      {schema?.forms?.officeLocation && (
        <>
          <AddressWork
            showCommandButton={!schema.forms.officeLocation.disabled}
            schema={schema.forms.officeLocation}
            isEdit={isEditWidget.officeLocation && !schema.forms.officeLocation.disabled}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('officeLocation', _isEdit, setIsEditWidget)
            }
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}
